<template>
  <SectionCard id="advantage" :class="isPcFlag ? 'product-advantage-pc' : 'product-advantage-h5'" :isPcFlag="isPcFlag" title="产品优势">
    <div class="advantage-content" v-if="isPcFlag">
      <ul class="tab_title">
        <li v-for="(v, i) in dataList" :class="m == i ? 'active' : ''" @click="m = i" :key="i.title">{{ v.title }}</li>
      </ul>
      <!-- 内容 -->
      <div class="tab_content">
        <div class="content-item" v-for="(v, i) in dataList" v-show="m == i" :key="i">
          <div class="title">{{ v.title }}</div>
          <div class="desc" v-if="v.descOne">
            <span>{{ v.descOne }}</span>
            <span class="num">{{ v.num }}</span>
            <span>{{ v.descTwo }}</span>
          </div>
          <div class="desc" v-else>{{ v.desc }}</div>
          <img class="img" :src="v.img" alt="" />
        </div>
      </div>
    </div>
    <div class="h5-advantage-content" v-else>
      <div class="content-item" v-for="(item, index) in dataList" :key="index" @click="activeItem(index)">
        <div class="title" :class="activeIndex[index] ? 'active-item' : ''">
          <p class="text">{{ item.title }}</p>
          <img class="icon" src="@/assets/images/landing-signet/h5_bottom.png" v-show="!activeIndex[index]" alt="" />
          <img class="icon" src="@/assets/images/landing-signet/h5_top.png" v-show="activeIndex[index]" alt="" />
        </div>
        <div class="content-box" v-show="activeIndex[index]">
          <div class="desc" v-if="item.descOne">
            <span>{{ item.descOne }}</span>
            <span class="num">{{ item.num }}</span>
            <span>{{ item.descTwo }}</span>
          </div>
          <div class="desc" v-else>{{ item.desc }}</div>

          <img class="img" :src="item.img" alt="" />
        </div>
      </div>
    </div>
  </SectionCard>
</template>

<script>
export default {
  props: {
    isPcFlag: Boolean, // 是Pc还是H5
    dataList: Array,
  },
  components: {
    SectionCard: () => import('@/components/basics/SectionCard.vue'),
  },
  data() {
    return {
      m: 0,
      activeIndex: [true],
    }
  },
  methods: {
    activeItem(index) {
      this.activeIndex[index] = !this.activeIndex[index]
      this.activeIndex = [...this.activeIndex]
    },
  },
}
</script>

<style lang="less" scoped>
.basisDisplay(@justify,@align) {
  display: flex;
  justify-content: @justify;
  align-items: @align;
}
.columnDisplay(@justify,@align) {
  display: flex;
  flex-direction: column;
  justify-content: @justify;
  align-items: @align;
}
// pc样式
.product-advantage-pc {
  .advantage-content {
    .basisDisplay(center,center);
    background: linear-gradient(270deg, #f8f9fb 0%, #ffffff 100%);
    border-radius: 4px;
    border: 2px solid #ececec;
    .tab_title {
      width: 360px;
      li {
        width: 100%;
        height: 91px;
        margin-bottom: 14px;
        background: #f1f2f5;
        box-shadow: 0px 4px 7px 0px #ffffff;
        border-radius: 4px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 28px;
        .basisDisplay(center,center);
      }
      li:last-child {
        margin-bottom: 0;
      }
      li:hover {
        cursor: pointer;
      }
      li.active {
        background: linear-gradient(270deg, #e63740 0%, #ff8866 59%, #fff3c7 100%);
        color: #ffffff;
      }
    }
    .tab_content {
      width: 960px;
      padding: 40px 53px 19px 38px;
      .content-item {
        .title {
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          line-height: 33px;
          padding-left: 44px;
        }
        .desc {
          width: 718px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 30px;
          margin: 20px 0;
          padding-left: 44px;
          .num {
            color: #e63740;
          }
        }
      }
    }
  }
}

// h5样式
.product-advantage-h5 {
  .h5-advantage-content {
    .content-item {
      width: 100%;
      height: auto;
      .title {
        padding: 0 0.32rem;
        .basisDisplay(space-between,center);
        width: 100%;
        height: 1.2267rem;
        background: #f1f2f5;
        border-radius: 0.1067rem;
        border: 0.0267rem solid #e4e4e4;
        color: #272727;
        font-size: 0.3733rem;
        margin-bottom: 0.3733rem;
        .text {
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
        }
        .icon {
          width: 0.6667rem;
          height: 0.6667rem;
        }
      }
      .active-item {
        background: linear-gradient(270deg, #e63740 0%, #ff8866 66%, #ffa17d 100%);
        border-radius: 0.1067rem 0.1067rem 0 0;
        border: 0.0533rem solid #ffffff;
        font-size: 0.4267rem;
        color: #ffffff;
        margin-bottom: 0;
      }
      .content-box {
        padding: 0.3733rem 0.32rem;
        background: #f8f9fb;
        box-shadow: 0 0.0533rem 0.2133rem 0 #d7e1ed;
        border-radius: 0 0 0.1067rem 0.1067rem;
        margin-bottom: 0.3733rem;
        .desc {
          line-height: 0.5333rem;
          margin-bottom: 0.5333rem;
          // font-size: 0.3733rem;
          font-size: 0.3733rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          .num {
            color: #e63740;
          }
        }
        .img {
          margin-bottom: 0.2667rem;
        }
      }
    }
  }
}
</style>